<template>
  <a-modal v-model="visible" title="创新拔尖人才对比模板选择" width="800px" @ok="submit" @cancel="closeModal(true)">
    <div class="modal-container">
      <a-table
        :rowSelection="rowSelection"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
        :columns="columns"
        row-key="id"
        :scroll="{ y: 450 }"
      >
        <span slot="name" slot-scope="text">
          <a-tooltip>
            <template slot="title"> {{ text.description }}</template>
            {{ text.name }}
          </a-tooltip>
        </span>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
export default {
  name: 'UploadStudent',
  data() {
    return {
      columns: [
        {
          title: '',
          scopedSlots: { customRender: 'name' },
        },
      ],
      tableRelevant: tableRelevant.call(this, this.getList),
      DownloadTemplate: process.env.VUE_APP_TEMPLATE_URL + '/template/excel/%E5%AF%BC%E5%85%A5%E5%88%9B%E6%96%B0%E4%BA%BA%E6%89%8D%E6%A8%A1%E7%89%88.xlsxs',
      confirmLoading: false,
      visible: false,
      selectedRowKeys: [],
    }
  },
  computed: {
    rowSelection() {
      return {
        hideDefaultSelections: true,
        selectedRowKeys: this.selectedRowKeys,
        getCheckboxProps() {
          return {}
        },
        onSelect: (record, selected) => {
          if (selected) {
            if (this.selectedRowKeys.length >= 3) {
              this.$message.error('创新拔尖人才对比模板选择最多勾选3个')
              return
            }
            this.selectedRowKeys.push(record.id)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((v) => record.id != v)
          }
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          if (selected) {
            for (let i = 0; i < changeRows.length; i++) {
              if (this.selectedRowKeys.length > 3) {
                return
              }
              this.selectedRowKeys.push(changeRows[i].id)
            }
          } else {
            const changeKeys = changeRows.map((v) => v.id)
            this.selectedRowKeys = this.selectedRowKeys.filter((item) => !changeKeys.includes(item))
          }
        },
      }
    },
  },
  methods: {
    async submit() {
      const params = {
        groupReportId: this._options.groupReportId,
        templateIds: this.selectedRowKeys,
      }
      await this.$http.ReportService.updateTalentContrastTemplate(params)
      this.$message.success('操作成功')
      this.closeModal(undefined, {
        templateIds: this.selectedRowKeys,
      })
    },
    async getList(reset) {
      if (reset) {
        this.tableRelevant.tablePagination.current = 1
      }
      this.tableRelevant.tableLoading = true
      const params = {
        TemplateType: 1,
        pageIndex: this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
      }
      this.$http.GroupReportTemp.getList(params)
        .then((res) => {
          const { status, data, message } = res
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = data.totalCount
          this.tableRelevant.tablePagination.current = data.pageIndex
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    showModal(options) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.visible = true
        this._options = options
        this.selectedRowKeys = options.templateIds || []
        this.getList()
      })
    },
    closeModal(reject, params) {
      reject ? this._reject(params) : this._resolve(params)
      this.visible = false
    },
  },
}
</script>
<style lang="less" scoped>
.modal-container {
  ::v-deep th .ant-checkbox-wrapper {
    display: none;
  }
}
</style>
